import React, { useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Breadcrumbs,
} from "@mui/material";
import { Payments } from "@mui/icons-material";
import { ThemeProvider } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import { themes, sideBarWidth, theme } from "services/constants";
import { Penalties } from "./DeductionComponents.js/Penalties";
import { FilterProvider } from "pages/FilterContext";
import { setFilterApi } from "services/Redux/userManagament";

export const DeductionComponents = () => {
  const [selectedShiftItem, setSelectedShiftItem] = useState("Penalties");
  const shiftSidebarOpen = true;
  const { domain, userScreenAccess, userDetails } = useSelector(
    (state) => state.tokenReducer
  );

  const shiftModule = userScreenAccess?.module_details?.find(
    (mod) => mod.module_name === "Deductions"
  );
  const dispatch = useDispatch();

  const subModuleId = shiftModule?.submodules?.find(
    (sub) => sub.sub_module_name === selectedShiftItem
  )?.sub_module_id;

  const shiftMenuItems = [
    {
      type: "title",
      title: "Shift",
    },

    {
      type: "item",
      title: "Penalties",
      key: "Penalties",
      subtitle: "View salary deductions",
      icon: <Payments />,
      color: "#6c757d",
    },
  ];

  const handleShiftItemClick = (itemTitle) => {
    if (selectedShiftItem === itemTitle) return;
    setSelectedShiftItem(itemTitle);
    dispatch(setFilterApi(true));
  };

  const renderMainContent = () => {
    switch (selectedShiftItem) {
      case "Penalties":
        return (
          <FilterProvider
            domain={domain}
            userDetails={userDetails}
            subModuleId={subModuleId}
          >
            <Penalties />
          </FilterProvider>
        );

      default:
        return <Penalties />;
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          height: "94.5vh",
          backgroundColor: themes?.whiteColor,
        }}
      >
        <Box
          sx={{
            width: shiftSidebarOpen ? sideBarWidth : 0,
            transition: "width 0.3s ease",
            overflowX: "hidden",
            flexShrink: 0,
            mt: "10px",
            backgroundColor: themes?.whiteColor,
            borderRight: "1px solid #f5f5fd",
          }}
        >
          <List sx={{ p: 2 }}>
            {shiftMenuItems.map((item, index) =>
              item.type === "title" ? (
                <Typography
                  key={`title-${index}`}
                  variant="subtitle"
                  sx={{ fontWeight: 700, color: "#00D4AA", mt: 2, mb: 2 }}
                >
                  {item.title}
                </Typography>
              ) : (
                <ListItem key={item.title} disablePadding sx={{ mb: 1, mt: 1 }}>
                  <ListItemButton
                    onClick={() => handleShiftItemClick(item.key)}
                    sx={{
                      backgroundColor:
                        selectedShiftItem === item.key
                          ? "#f0f8ff"
                          : "transparent",
                      borderRadius: 1,
                      p: 1,
                      "&:hover": { backgroundColor: "#f8f9fa" },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: "38px",
                        color:
                          selectedShiftItem === item.key
                            ? "#00D4AA"
                            : item.color,
                      }}
                    >
                      {item.icon}
                    </ListItemIcon>
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {item.title}
                      </Typography>
                      <Typography variant="caption" sx={{ fontWeight: 600 }}>
                        {item.subtitle}
                      </Typography>
                    </Box>
                  </ListItemButton>
                </ListItem>
              )
            )}
          </List>
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            p: 3,
            minWidth: 0,
            backgroundColor: "#f5f5fd",
            transition: "all 0.3s ease",
          }}
        >
          {shiftSidebarOpen && (
            <Breadcrumbs aria-label="breadcrumb" separator="›" sx={{ mb: 2 }}>
              <Typography>Payroll</Typography>
              <Typography>Components</Typography>
              <Typography>Deductions</Typography>
              <Typography color={themes?.blueColor}>
                {selectedShiftItem}
              </Typography>
            </Breadcrumbs>
          )}

          {renderMainContent()}
        </Box>
      </Box>
    </ThemeProvider>
  );
};
